// Copyright 2023 Carnegie Mellon University. All Rights Reserved.
// Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.

import { EntityState, EntityStore, Store, StoreConfig } from '@datorama/akita';
import { Invitation } from 'src/app/generated/blueprint.api';
import { Injectable } from '@angular/core';

export interface InvitationState extends EntityState<Invitation> {}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'invitations' })
export class InvitationStore extends EntityStore<InvitationState> {
  constructor() {
    super();
  }
}
